const map = {
	"./credentials_leak.svg": 60413,
	"./fraudulent_activity.svg": 27627,
	"./impersonation_attempt.svg": 81985,
	"./new_domain_registered.svg": 30791,
	"./new_email_address.svg": 85369,
	"./new_hostname_found.svg": 52018,
	"./new_ssl_certificate_found.svg": 70931,
	"./new_vulnerability.svg": 23862,
	"./new_vulnerable_asset_found.svg": 39284,
	"./personal_information_exposure.svg": 18614,
	"./potential_phishing.svg": 10172,
	"./targeting_disclosure.svg": 84678,
	"./underground_activity.svg": 38984
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6166;